/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from 'react-router';
import { useEffect } from 'react';

import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import ErpDetailInfo from './lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';

import * as S from './styles';

export default function ErpDetailPage() {
  const params = useParams();

  const { detail }: any = useTypedSelector((state) => state.Erp);
  const { erpDetailRequestAction } = useActions();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    erpDetailRequestAction(params?.id);
  };

  console.log(detail);

  return (
    <S.Container>
      <S.Head>
        <S.Title>ERP Request Detail</S.Title>
      </S.Head>
      <Gap size="20px" />

      <S.Div>
        <ErpDetailInfo data={detail.data} />
      </S.Div>

      <AppLoading loading={detail.loading} />
    </S.Container>
  );
}
